// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".candidate-notes{margin:-2rem!important}", "",{"version":3,"sources":["webpack://./resources/js/app/Component/Views/Candidates/Tabs/CandidateNotes.vue"],"names":[],"mappings":"AACA,iBACI,sBAAJ","sourcesContent":["\n.candidate-notes {\n    margin: -2rem !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
